import { Type } from '@angular/core';
import { PageFilterItem } from '../types/page-filter-item';
import { FilterOperator } from '../../types/filter-operators';
import { FilterInputBase } from '../components/filter-inputs/filter-input.base';
import { DateRangeReferenceFilterInputComponent } from '../components/filter-inputs/date-range-reference-filter-input/date-range-reference-filter-input.component';

/** The editor for an item: the reference kind is not distinguishable by (type, operator), so it is resolved off the item. */
export function resolveFilterInputComponent<T extends object>(
  item: PageFilterItem<T, any>,
  operator: FilterOperator
): Type<FilterInputBase<T, FilterOperator>> {
  if (item.kind === 'dateRangeReference')
    return DateRangeReferenceFilterInputComponent as unknown as Type<FilterInputBase<T, FilterOperator>>;
  return item.config.inputTypeFactory(item.config.type, operator);
}
